import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { ROUTES } from "./constants";
import { protectedRoute } from "./helpers";

const GalileoPage = lazy(() => import("@/features/galileo"));

export const galileoRoutes: RouteObject[] = [
	{
		path: ROUTES.GALILEO,
		element: protectedRoute(<GalileoPage />),
	},
];
